module.exports = __webpack_public_path__ + "img/12.c6584f26.jpg";